import { createSvgIcon } from '@mui/material';

export const Check = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.6666 5L7.49998 14.1667L3.33331 10"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'Check',
);
